const projectData = [
    {
        id: 1,
        img: 'https://res.cloudinary.com/ddl9lwciz/image/upload/v1674049699/Capture1_wvxf1o.png',
        title: "Food Delivery App",
        desc: "This is a fully functional E-commerce app with context API and UseReducer hook.",
        toolsUsed: "JavaScript ReactJs Bootstrap Netlify GitHub",
        gitHubLink: "https://github.com/piyushkesarwani/E-commerce-app",
        liveLink: "https://ecommer-app.netlify.app/",
    },
    {
        id: 2,
        img: 'https://res.cloudinary.com/ddl9lwciz/image/upload/v1674049710/Capture2_kcjq2h.png',
        title: "2D Snake Game",
        desc: "This is a simple 2D Snake Game made from scratch with HTML, CSS, and vanilla JAvaScript.",
        toolsUsed: "HTML CSS and Vanilla JavaScript.",
        gitHubLink: "https://github.com/piyushkesarwani/Snake-Game",
        liveLink: "https://2dsnake-game.netlify.app/",
    },
    {
        id: 3,
        img: 'https://res.cloudinary.com/ddl9lwciz/image/upload/v1674049728/Capture3_nv5z1m.png',
        title: "Auxo Digitals Website",
        desc: "This is a Digital Marketing website built for a client.",
        toolsUsed: "JavaScript JavaScript Bootstrap Netlify Git",
        gitHubLink: "https://github.com/piyushkesarwani/auxo-digitals",
        liveLink: "https://auxo-digitals.netlify.app/",
    },
    {
        id: 4,
        img: 'https://res.cloudinary.com/ddl9lwciz/image/upload/v1674049733/Capture4_hdg2ft.png',
        title: "Weather Forecast App",
        desc: "A weather forecast application built which uses API calls to fetch all datas of a particular city on the screen",
        toolsUsed: "JavaScript ReactJS RapidAPI Bootstrap Netlify",
        gitHubLink: "https://github.com/piyushkesarwani/Weather-forecast-app",
        liveLink: "https://weatherorecast.netlify.app/",
    },
    {
        id: 5,
        img: 'https://res.cloudinary.com/ddl9lwciz/image/upload/v1674049743/Capture5_zmo6um.png',
        title: "Cryptocurrency Tracker",
        desc: "An app which shows all the details of a cryptocurrency token, like market cap, price, name, etc",
        toolsUsed: "JavaScript ReactJs RapidAPI BootStrap Netlify",
        gitHubLink: "https://github.com/piyushkesarwani/Crypto-tracker",
        liveLink: "http://crypto-hunting.netlify.app",
    },

]

export default projectData;